module.exports = __webpack_public_path__ + "img/heroFormActive1.31d63bf1.svg";